<template>
  <v-row dense>
    <v-col>
      <v-row><v-col>
          <!-- {{attendance}} -->
        </v-col></v-row>
      <v-row dense>
        <v-col cols="6">
          <v-select
            v-model="applicationRouteId"
            outlined
            dense
            label="*Uso do medicamento"
            placeholder="Selecione o uso do medicamento..."
            :items="medicineApplicationRoutes"
            item-text="name"
            item-value="id"
            :hide-details="errors.applicationRoute === undefined"
            :error-messages="errors.applicationRoute"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Intervalo"
            :items="prescriptionFrequencies"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Quando"
            :items="prescriptionPeriods"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>

        <v-col>
          <v-combobox
            v-model="preset"
            outlined
            dense
            label="Período"
            :items="prescriptionHowLongs"
            item-text="name"
            hide-details
            @change="(e) => concatPreset(lodash.get(e, 'name', ''))"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12">
          <v-textarea
            v-model="description"
            outlined
            dense
            label="*descreva a medicação extra e sua posologia"
            item-text="name"
            :hide-details="errors.description === undefined"
            :error-messages="errors.description"
            @change="debouncedSavePrescriptionNewMed"
            background-color="white"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <v-row justify="space-between">
        <v-col cols="auto" class="gray--text">
          <v-btn @click="hideForm" color="gray lighten-1" dark>minimizar</v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn v-if="true" @click="savePrescriptionNewMed" outlined color="light-blue">incluir outro medicamento Extra</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>

</template>

<script>
import SAVE_PRESCRIPTION_NEW_MED from "@/graphql/prescription/save_prescription_new_med.gql";

export default {
  name: "PrescriptionFormNewMed",
  props: {
    attendance: Object,
    prescriptionId: String,
    prescriptionNewMed: {
      type: Object,
      default: () => {
        return {
          id: "",
        };
      },
    },
    prescriptionInput: Object,
    clearFlag: String,
    refreshList: Function,
    prescriptionFrequencies: Array,
    prescriptionPeriods: Array,
    prescriptionHowLongs: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    hideForm: Function,
    addNewItem: Function,
  },
  data() {
    return {
      errors: {},
      typing: false,
      prescriptionNewMedId: "",
      applicationRouteId: "",
      description: "",
      preset: "",
    };
  },
  mounted() {
    this.refreshList();
    this.refresRoutes();
  },
  apollo: {
    medicineApplicationRoutes: {
      query: require("@/graphql/medicine/medicine_application_routes.gql"),
      update(data) {
        return this.lodash.orderBy(
          data.medicineApplicationRoutes,
          ["createdAt"],
          ["desc"]
        );
      },
    },
  },


  watch: {
    description() {
      this.typing = true;
      this.preset = { name: "" };
      this.debouncedSavePrescriptionNewMed();
    },
    prescriptionNewMed() {
      this.loadNewMed();
    },
    clearFlag() {
      this.errors = {};
      this.typing = false;
      this.prescriptionNewMedId = "";
      this.description = "";
    },
    prescriptionInput() {
      if (this.prescriptionNewMedId !== "") {
        this.debouncedSavePrescriptionNewMed();
      }
    },
  },
  created: function () {
    this.loadNewMed();

    this.debouncedSavePrescriptionNewMed = this.lodash.debounce(
      this.savePrescriptionNewMed,
      2000
    );
  },
  methods: {
    concatPreset(text) {
      this.description += ` ${text}`;
      this.description = this.description.trim();
    },
    loadNewMed() {
      if (this.prescriptionNewMed.id !== "") {
        this.prescriptionNewMedId = this.prescriptionNewMed.id;

        if (!this.typing) {
          this.description = this.prescriptionNewMed.description;
        }
      }
    },
    refresRoutes() {
      this.$apollo.queries.medicineApplicationRoutes.refetch();
    },
    validatePrescriptionItem() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (this.lodash.isEmpty(this.description.trim())) {
         this.errors.description = errorMsg;
       }
       if (!this.applicationRouteId) {
        this.errors.applicationRoute = errorMsg;
      }     

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    savePrescriptionNewMed() {
      if (this.disabled) return;

      if (this.prescriptionNewMedId === "" && this.description === "") return;
      if (!this.validatePrescriptionItem()) return;

      this.apolloMutate({
        mutation: SAVE_PRESCRIPTION_NEW_MED,
        variables: {
          attendanceId: this.attendance.id,
          prescriptionId: this.prescriptionId,
          prescriptionNewMedId: this.prescriptionNewMedId,
          applicationRouteId: this.applicationRouteId,
          description: this.description,
          prescriptionInput: this.prescriptionInput,
        },
      }).then(({ data }) => {
        this.typing = false;

        this.$emit(
          "updatePrescriptionId",
          data.savePrescriptionNewMed.prescription.id
        );
        this.prescriptionNewMedId = data.savePrescriptionNewMed.id;
        
        this.refreshList();

        this.addNewItem();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
